/// Menu
import MetisMenu from "metismenujs";
import React, { Component, useState, useContext, useEffect } from "react";

/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
// import useScrollPosition from "use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import axios from "axios";
import Baseurl from "../../../Baseurl";
import swal from "sweetalert";
import firebase from "firebase/app";
import { useHistory } from "react-router-dom";
import "firebase/messaging";
import song from "../../../images/vikki.wav";
import useSound from "use-sound";
import icon from '../../../images/logo.png'
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
    //  this.mm("dispose");
    // console.log(this.mm);
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}
const SideBar = () => {
  const [plays, { stop }] = useSound(song);
  const history = useHistory();
  // const messaging = firebase.messaging();
  var userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [appliedStatus, setAppliedStatus] = useState(false);
  const [riderCount, setRiderCount] = useState("");
  //const[pathData,setPathData]=useState(path)
  const [permission, setPermission] = useState("");
  /// Path
  let path = window.location.pathname;
  var realPath = path;
  path = path.split("/");
  path = path[path.length - 1];
  let paths = path[path.length - 2];

  const { iconHover, sidebarposition, headerposition, sidebarLayout } =
    useContext(ThemeContext);
  let staff = ["all-staff", "all-roles", "new-staff", "add-roles"],
    pricing = ["category-pricing", "pricing-list", "taxes"],
    geoPaths=["Geofences","Create Geofence","All-Polylines"],
    rider = [
      "edit-rider",
      "riders",
      "rider-applied",
      "blocked-rider",
      "Training",
      "rejected-riders",
      "Rider-View",
    ],
    user = ["user-customer", "deleted-user"],
    grocery = ["stores", "Sub-Store", "products","Grocery-Category","Grocery-SubCategory","WareHouses","Shop-Admin","Gocery-Banners"],
    order = ["all-orders","Order-Ratings"],
    analitic = ["Category-Analytics","All-Analytics"],
    support = ["support", "customer-support", "FAQ","App-Update"],
    services = ["Experts-List", "Applied-Experts", "Subscription","Service-Category"],
    transaction = ["transaction", "payout","Payment Options"],
    airport=["AirPort-Orders","Airport-Assigned-Orders","Airport-UnAssigned-Orders"],
    rental=["Rentals-Orders","Rentals-Assigned-Orders","Rentals-UnAssigned-Orders"],
    food = [
      "Restaurant-Owners",
      "Applied-Owners",
      "Blocked-Owners",
      "Applied-Restaurants",
      "Verified-Restaurant",
      "Blocked-Restaurants",
      "All-Items",
      "Applied-Items",
      "All-Addons",
      "Applied-Addons",
      "Food Coupens",
      "Home Category",
      "Food Campaign",
      "Applied Campaign",
      "Food Banner",
      "Banner Campaign Payment",
      "Applied Banners",
      "Penalty Restaurants",
      "Menu Reviews"
      
    ],
    diagnostics = [
      "Packages",
      "Package Banner",
      "Tests",
      "Package Category",
      "Main Category",
      "Health Centers",
      "Sub Tests",
      "Rider-Register",
      "Delivery Charge"
    ],
    partner = ["partner", "applied-partners", "blocked-partner"],
    marketing = [
      "Offers",
      "banners",
      "trending-banners",
      "go-category",
      "coupens",
      "logingif",
      "CashBack",
      "Movers Categories",
      "Quotes"
    ];
  useEffect(() => {
    getData();
  }, []);
  if (firebase.messaging.isSupported()) {
    firebase.messaging().onMessage((notification) => {
      plays();
      if (notification.data.title==="Rider") {
        swal({
          title: `${notification.data.title}`,
          text: `${notification.data.body}`,
          type: "danger",
          timer: 12000,
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
        }).then(function (isConfirm) {
          if (isConfirm) {
            stop();
            history.push("/rider-applied");
          }
        });
      } else
      if (notification.data.title==="User") {
        swal({
          title: `${notification.data.title}`,
          text: `${notification.data.body}`,
          type: "danger",
          timer: 12000,
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
        }).then(function (isConfirm) {
          if (isConfirm) {
            stop();
            history.push(`/show-order/${notification.data.orderId}`);
          }
        });
      }
      else
      if(notification.data.title==="Airport"){
        swal({
          title: `${notification.data.title}`,
          text: `${notification.data.body}`,
          type: "danger",
          timer: 12000,
          showCancelButton: true,
          confirmButtonClass: "btn-danger",
          confirmButtonText: "Yes, delete it!",
          closeOnConfirm: false,
        }).then(function (isConfirm) {
          if (isConfirm) {
            stop();
            history.push(`/AirPort-Orders`);
          }
        });
      }
    });
  }

  function getData() {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    //sidebar icon Heart blast
    var handleheartBlast = document.querySelector(".heart");
    function heartBlast() {
      return handleheartBlast.classList.toggle("heart-blast");
    }

    handleheartBlast.addEventListener("click", heartBlast);
    axios.get(`${Baseurl.baseurl}/roles/get-roles`).then((response) => {
      response.data.details.map((val) => {
        if (val.Title === userDetails.staff.Role) {
          setPermission(val.Permissions);
          localStorage.setItem("permissions", JSON.stringify(val.Permissions));
          getApliedRider(val.Permissions);
        }
      });
    });
  }
  function getApliedRider(val) {
    axios
      .get(Baseurl.baseurl + "/rider/get-all-not-assigned-riders")
      .then((response) => {
        if (response.data.riders) {
          setRiderCount(response.data.riders.length);
          if (val.includes("Riders Applied")) {
            setAppliedStatus(true);
            swal({
              title: "Rider Applied?",
              text: `you got ${response.data.riders.length} applied riders`,
              type: "danger",
              timer: 1500,
              showCancelButton: true,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Yes, delete it!",
              closeOnConfirm: false,
            });
          }
        } else {
          //callAudio()
        }
      });
  }
  
  return (
    <div
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? ""
          : ""
      }`}
    >
      {/* <!-- Add Project --> */}

      <PerfectScrollbar className="deznav-scroll">
        {permission && (
          <MM className="metismenu" id="menu">
            {permission.includes("Dashboard") && (
              <li className={`${path === "" ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  <i className="flaticon-047-home"></i>
                  <span className="nav-text">Dashboard</span>
                </Link>
                <ul>
                  <li>
                    <Link
                      className={`${path === "/" ? "mm-active" : ""}`}
                      to="/"
                    >
                      Dashboard
                    </Link>
                  </li>
                </ul>
              </li>
            )}
            {(permission.includes("All Users") ||
              permission.includes("Deleted User")||permission.includes("User Analytics")) && (
              <li className={`${user.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  <i>
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABsElEQVRIie2Wv0scQRiGn2+3CemEWAkJOf+B3M7eQZo04UgVIgqHjZ2WgoRIsLax8D9IOgv12jQRrAIhhJ3b4roUXidEkkIsRJbcTBqFeHi33xx7qXzLb17eZ75v9sfAvf6TJMRsrZ0H3gItYA64BL567983Go0fUwFbaxeAfeDBHctnIrItIp0kSX5VBr7utAc8LLGeOufSZrP5sywz0oBFZEMBBZgTkXVNpgrsvW9pfAAi8qYyMPBECwYeVwm+CACrpB11rg0Uke+VgUXkjxbsvb+qDAzUtWDgWZXgwwCwyqv+cmVZdiwiL8eGiRwbY1SvnrZjoijaVdg0njCwMeYzsDPGsmWMOdLmBf2dAKy1/q56mqZBWeqOq1YQOMuypVFr3W53MSSrdDydTieu1WovgFVgmdGbdcAB8LHf739pt9uDicB5nj8fDAZrIvIaeFS2wSH99t5/iuP4Q5Ik31TgPM9nnXN7wKtA2CgdRVG0MnwzuQXu9XozRVFYoFYR9EYncRyn9Xr9/KZw67yKoticAhRg3jn37t/C8IOiuj1MIu/9wjjw02mBmc4k71Wuv2Dzc1X6n+arAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">k Health Users</span>
                </Link>
                <ul>
                  {permission.includes("All Users") && (
                    <li>
                      <Link
                        className={`${
                          path === "user-customer" ? "mm-active" : ""
                        }`}
                        to="/user-customer"
                      >
                        All Users
                      </Link>
                    </li>
                  )}
                   {permission.includes("User Analytics") && (
                    <li>
                      <Link
                        className={`${
                          path === "User-Analytics" ? "mm-active" : ""
                        }`}
                        to="/User-Analytics"
                      >
                        User Analytics
                      </Link>
                    </li>
                  )}
                  {/* {permission.includes("Deleted User") && (
                    <li>
                      <Link
                        className={`${
                          path === "deleted-user" ? "mm-active" : ""
                        }`}
                        to="/deleted-user"
                      >
                        Deleted User
                      </Link>
                    </li>
                  )} */}
                </ul>
              </li>
            )}
             {permission.includes("Packages") ||
            permission.includes("Tests") ||
            permission.includes("Package Category") ||
            permission.includes("Main Category") ||
            permission.includes("Package Banner") ||
            permission.includes("Health Centers") ||
            permission.includes("Sub Tests") ||
            
            permission.includes("Delivery Charge") ? (
              <li
                className={`${diagnostics.includes(path) ? "mm-active" : ""}`}
              >
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img height={26} width={26} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAADt0lEQVR4nO1bPWgUQRRejYraSKwEsRKsTLBVtFD8aRSrCFpFDApaqGChIlwsFAuDwdy8c+ad+94JabYRbLQR0SB2gqj4U/iHkk4N2vh7Mrm5yyX3k7ns7rl7mQ+WhN23b9588+Z7M7t7HiA/BORiqEPRxIj0e7w2QSD36jZDx4005oV3wkWB/LXdBOg2o4jdq/wzz+AIQJcBxf86BYTvrwHlb8nKwuYs0ap5kQGZTGYhIA8Ixc9rhFTRY0D/QLFYXNCRBACMdgvku1Ul6LMuwQL5ESB9myqpfHNoKFjWUQRkMvcW6ZprOvgpp3hfEARd5etEtDSHfKRS2hTfijsT2kqAyPOp0nqB3udyvLqRnV5LlEnIKurvCAKCIOgCxeOlkfW3zWYvFB0qaQK/9DqBgGv5wkYjck9t7KWUi0HxF33PiCqsSz0BWUX9ZkSv295TEUtV2J16AgB5wLSRs75H8e2SDhT2pp8AWdhuNkwPbOy1+oPiD0YIN6SeACnlclD0XSj6bTOnc+jvMKVwXC+cOqIMAtJwOQuCIFjS0A5GuwHplSHgXLwxlQlQNKFrb5yNSSlXCOS3pY7RfSl57Uwbne66UpQrhl4cxRlTpd8j0u+B/I31cTVUKmuFXVoEqx6g/BRId4TiywL5is4MQP5TtUweEnneqe+NK664+z2JrOL9euk79ydN9BHy1OelEaD4/NQGh57okQakS5bHMCA9q9ognfXSBMhTn5nLPwTywbn40OVQyMJRQPolFP0V6O/x0oCM3vkpfmdG73BYf1nkk0Y3XsdZFiODyPNWE/CLKLa0k5sppDeTPqW/yUs6hOTjZvSvRuWzUkEUHfOSDlCcMQo+GJVP7cuIYcZLOoQJtpoAUHRRIF2w9THTvp7PxELUCVaruF7oWPuYYd9WAmDau0Iaa/V63Qyos99o5memfTMCwsZbg8rDywZb2Nmu2xPQ2E9rBISLN3LYEtAMrRCQOAhHALkMgDRNAWj6hciUatra2UyB+r6mtTUrAZHFDVUqWbsfn1JNWzs7Amp9TW/LhoBo444MTgTRieCgrQiW5mfd1Vua1wF8xgjMaQsCrM7X85lYIOJKUHRC/42KgHo+UwUISUDqAY4AdhkASZ0CArk37u98kzgFKv2GNrwcTSIBlX5DOxpLIgHlNsARwC4DwE0BdhrgtUNwQp6PJSZwGsBOA8BpADsN8NohOCHPxxITOA1gpwHgNIDj/lh6rNG7+1bOx6oBMC9/Pc6agMbvzmyPtP56XGfZP2JgMRRnRt1vAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Diagnostics</span>
                </Link>
                <ul>
                  {permission.includes("Sub Tests") && (
                    <li>
                      <Link
                        className={`${path === "Sub-Tests" ? "mm-active" : ""}`}
                        to="/Sub-Tests"
                      >
                        Sub Tests
                      </Link>
                    </li>
                  )}
                  {permission.includes("Tests") && (
                    <li>
                      <Link
                        className={`${path === "Test" ? "mm-active" : ""}`}
                        to="/Test"
                      >
                        Tests
                      </Link>
                    </li>
                  )}
                 
                  {permission.includes("Packages") && (
                    <li>
                      <Link
                        className={`${path === "package" ? "mm-active" : ""}`}
                        to="/package"
                      >
                        Packages
                      </Link>
                    </li>
                  )}
                   {permission.includes("Package Category") && (
                    <li>
                      <Link
                        className={`${
                          path === "Package-Category" ? "mm-active" : ""
                        }`}
                        to="/Package-Category"
                      >
                        Package Category
                      </Link>
                    </li>
                  )}
                    {permission.includes("Main Category") && (
                    <li>
                      <Link
                        className={`${
                          path === "Main-Category" ? "mm-active" : ""
                        }`}
                        to="/Main-Category"
                      >
                        Main Category
                      </Link>
                    </li>
                  )}
                  {permission.includes("Health Centers") && (
                    <li>
                      <Link
                        className={`${
                          path === "Health-Center" ? "mm-active" : ""
                        }`}
                        to="/Health-Center"
                      >
                        Health Centers
                      </Link>
                    </li>
                  )}
                  {permission.includes("Package Banner") && (
                    <li>
                      <Link
                        className={`${
                          path === "Package-Banner" ? "mm-active" : ""
                        }`}
                        to="/Package-Banner"
                      >
                        Package Banner
                      </Link>
                    </li>
                  )}
                  
                   {permission.includes("Delivery Charge") && (
                    <li>
                      <Link
                        className={`${
                          path === "Delivery-Charge" ? "mm-active" : ""
                        }`}
                        to="/Delivery-Charge"
                      >
                        Delivery Charge
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            ) : null}
            {(permission.includes("Riders") ||
              permission.includes("Riders Applied") ||
              permission.includes("Blocked Riders") ||
              permission.includes("Training") ||
              permission.includes("rejected-riders") ||
              permission.includes("Rider-Register")||
              permission.includes("Rider Map View")) && (
              <li
                className={`${
                  rider.includes(path) ||
                  realPath.includes("edit-rider") ||
                  realPath.includes("rider-details")
                    ? "mm-active"
                    : ""
                }`}
              >
                <Link className="has-arrow ai-icon" to="#">
                  {" "}
                  <i>
                    {" "}
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACgklEQVRIie2WT2gTQRjF3zeNzVobsJUKoig9SQ1IK5tLG9HWQhVFe6roQTx5LSKIiCKiUEQoXgRPXkRBQTyKJy+h1mQ2erDiQRLUo1qlwZUGO8+DG9gs2Wbzp576Tt+8ecxvZneGGWBd/0lSLzA3N9cbj8cPkBwhmRSRfgB9ALoBrAD4CuANgBflcvnx8PDwYtNgkiqfz58wxpwTkXEAsYgLcUneXV5evpFOp0sNgbXWkwBuAkhGhNXSJwAnbdt+HRZQNbzpFqEAsAvAS8dxDkcGk7zeIrSijSSfZrPZwUhgpVS8TWAA6FJKPdJad9UFk7zSRjAADAC4GjSrNlcul9stIh/aDAaAXwC22rbtVoyqFYvI5BpAAWCTiEz4jeD5PNTkwDO2bV+u1ZHL5c6LyCzJ4wCeVfzgP94TlWSMGSGZ9ppnw3JKqVdeubfKD+S2RAWLiH9/bAjLdXR0fPHKnX4/+KnZADjjq++H5VzXXezs7ASAhN8PrvhHVLAPmltaWroWIbqyGvh7o2CSqUQi8V5rPZ3JZBLBfsuyemqNHTxObxsFe+oHcMeyrM+O49yan5/f4ZvYNq/8FgoGkEFr2kzyYiwWK2itH2qt9xljBgFARN6FgpVSTwD8bhEO/NvlpwE4InLb86quyCrw0NDQTxG51wawXz0AQPJUKBgALMu6BGAWwKoviCbUuyo4mUyWbdu+UCgUekTE9u5nB4BphUpyxt+u+9irKJ/P9xljDpIcF5GjALY3wP1YKpUGRkdH/zQMDiqbzSaVUsdEZJzkfgChDwiSZ1Kp1AO/1zTYr4WFhW7Xdce8q29CRJ4bYzpF5AjJYrFYHJuamlqpO9C61kJ/AcA70uVGhXVbAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">
                    Technicians{" "}
                    {appliedStatus && (
                      <i
                        class="fa fa-bell text-primary"
                        style={{ fontSize: 17 }}
                        aria-hidden="true"
                      >
                        {riderCount}
                      </i>
                    )}
                  </span>
                </Link>
                <ul>
                  {permission.includes("Riders") && (
                    <li>
                      <Link
                        className={`${path === "riders" ? "mm-active" : ""}`}
                        to="/riders"
                        onClick={() => {
                          localStorage.setItem("ridersapplied", "");
                        }}
                      >
                        All Technician
                      </Link>
                    </li>
                  )}

{permission.includes("Rider Register") && (
                    <li>
                      <Link
                        className={`${
                          path === "Rider-Register" ? "mm-active" : ""
                        }`}
                        to="/Rider-Register"
                      >
                        Rider Register
                      </Link>
                    </li>
                  )}
                  {permission.includes("Blocked Riders") && (
                    <li>
                      <Link
                        className={`${
                          path === "blocked-rider" ? "mm-active" : ""
                        }`}
                        to="/blocked-rider"
                        onClick={() => {}}
                      >
                        Blocked Technician
                      </Link>
                    </li>
                  )}
                  {permission.includes("Rider Map View") && (
                    <li>
                      <Link
                        className={`${
                          path === "Rider-View" ? "mm-active" : ""
                        }`}
                     
                        to="/Rider-View"
                      >
                        Technician Map View
                      </Link>
                    </li>
                  )}
                  {permission.includes("Training") && (
                    <li>
                      <Link
                        className={`${path === "Training" ? "mm-active" : ""}`}
                        to="/Training"
                      >
                        Training
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
           
          
           
            {(permission.includes("AllOrders")||permission.includes("Order Ratings")||permission.includes("All Analytics")) && (
              <li className={`${order.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#">
                  {" "}
                  <i>
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACBElEQVRIie2Wv4sTQRTHPzN7ETYg2HrgEWwsYjPJ7hZ3Nuktrpdod3+CnDbxB1jfv3DXWNgIClZyCP6A3QlbxUokeN7VNrJB2RkLsxDO3ctOkgMFv9Xu2/feZ957w84IHDUajS5MJpPH1to+YIED3/cH7Xb7h0ueNVdwlmWPgLszpt0syyxw3yWPdAUDfQBjzJa19sbUdsc1iSgznmrn5TKfAiqEeFuR+4QzxlDa6pJ2/rniamChdc4YQ1Wr+wBSys0gCEQQBAL4OgcEcFT4G2O2prbSMVSB1wE6nc6HwmCt3ZkDPxJC7BQvURS9n811WrV3dRiGr4Ardf3naZFd/W+DnX8gZUrTtJXn+UtgTQhxs9vtfpoXs5KKjTHbQBu4Zq19USdmqYrTNG0BKKX2kiS5JIQYAD/PFTxt7+H0uaeUejAcDr9JKZ+fG1hrvZHn+WugBZDn+ZskSXrdbnevbg7nGWutN4BD4Kpr7MLgCugXa20vDMPP5wJeJRQcZmyMuSilnF3o2PO8nlJq7AoFh4qjKBrx+6gcLwuFmhVrre95nvdUKfUsjuOPjUbj+zLQ2mDgljFGAE+mlS+tWuAgCK6vAjarv+5YPAGI43hz0cRJkhRXn+Oy71WtPgB2pZTvtNaLsgGw1u7XBvu+P8iyDOA2FXemGjq21u43m82HC8b/12r0C5c/xggGgvkKAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Order List</span>
                </Link>
                <ul>
                  {(permission.includes("AllOrders")||permission.includes("Order Ratings"))&&(
                     <li>
                     <Link
                       className={`${path === "all-orders" ? "mm-active" : ""}`}
                       to="/all-orders"
                     >
                       All Orders
                     </Link>
                   </li>
                  )}
                   {permission.includes("Order Ratings")&&(
                     <li>
                     <Link
                       className={`${path === "Order-Ratings" ? "mm-active" : ""}`}
                       to="/Order-Ratings"
                     >
                      Order Ratings
                     </Link>
                   </li>
                  )}
                   {permission.includes("All Analytics") && (
                    <li>
                      <Link
                        className={`${path === "All-Analytics" ? "mm-active" : ""}`}
                        to="/All-Analytics"
                      >
                        Order Analytics
                      </Link>
                    </li>
                  )}  
                 
                </ul>
              </li>
            )}

            {(permission.includes("Geofences")||permission.includes("Create Geofence")||permission.includes("All Geofence"))&& (
              <li className={`${geoPaths.includes(path)? "mm-active" : ""}`}>
                <Link
                  className="has-arrow ai-icon"
                  onClick={() => localStorage.setItem("geofenceuserid", " ")}
                >
                  {" "}
                  <i>
                    {" "}
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAmUlEQVRIie2UvQ3CMBBGv0OyR2ANF7kSFoB5YQEor/EajGAXR0EsEaM0ITYoutf5NU/+O8DYOlSLGOM+53wFAOfcKYTwePeqqt7781Jf2NXhMToAGFJKl9oTEX/jZ8Nj9HUcRNzAz4a7MLljEbkBODRq3Zn5WBY9d6wdW3/Ixz8WkcmRMDOt6Qs/e9UWtnAzbGRuHxuZhrEaT+iqeJJXZB0GAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Geofence</span>
                </Link>

                <ul>
                
                 
                  {permission.includes("Create Geofence")&&(
                     <li>
                     <Link
                       className={`${path === "polyLine" ? "mm-active" : ""}`}
                       to="/polyLine"
                     >
                       Create Geofence
                     </Link>
                   </li>
                  )}
                    {permission.includes("All Geofence")&&(
                     <li>
                     <Link
                       className={`${path === "All-Polylines" ? "mm-active" : ""}`}
                       to="/All-Polylines"
                     >
                       All Geofence
                     </Link>
                   </li>
                  )}
                 
                 
                  {/* <li><Link className={`${path === "pincode" ? "mm-active" : ""}`} to="/pincode">Update Geofence</Link></li> */}
                </ul>
              </li>
            )}

           

        
            {(permission.includes("Banners") ||
              permission.includes("Trending Banners") ||
              permission.includes("Offers") ||
              permission.includes("Go One Category") ||
              permission.includes("Movers Categories") ||
              permission.includes("Quotes") ||
              permission.includes("Customer Notification")||permission.includes("WareHouses")||permission.includes("Shop Admin")||permission.includes("Gocery Banners")) && (
              <li className={`${marketing.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACv0lEQVRIie2WO2gUURSGvzOZ2dhbKQYljSJoAnN3DbEKZMUHiijYi4pGLbURO8FCLHyiWFlIlJBCjVE0CBaCYfZuxELFQsU3CjaLxEg2cyyyA2MyO7Orm86//O9/z3efMxcSZK0dsdaOJLW1SgIQBEGH4zhbVPWLiBwENtTax1T1oogsCcNwtFAofGgV2AVwHGcLcElE5rYXRaRYywwAlwGstU+BVcA7VX0ODE9PT9/s7e392SjYAVDVz1nBOZlrwCJgpYjsEJHBXC73slQq7WwKLCKHY96o67rLqtVqh4jci8x4RkQeJdRaLiLD1toTqjpv6eaBrbV3gGJkVKvVA93d3Z96eno+zszM7I9li9GB8zzvTUrN4xMTE0cywYBmhSKpqgJUKpVqRu5kEAT5VLAxZiswFhme510ZHx9fFgRBh4hciWXH8vn8NoD29vblGWN029raTqaCayO8EBvtJtd1PziO815ENsb8C7F+RTKkqv3W2jWpYBFZmlUoygwNDbWJyN6sfK3PjlRwGIajwICqbie27Mx+QLYDA7UMnZ2dh4DVjYBVdX3dQSWZ1toRVdVoTyOVSqV+EbkLeI2AgffGmMTzkHnfYHZ5azM93QR0FiCy2/f9q6ngcrm8LwzDJ7lc7q3rujI5OblCRDYAe2hweRP0C+g3xjyuC7bWPgPW/iUgTd+BdcaY15HhzAm8WgAowGJgMG78ARaRWwsEBvhRF+y67k2g0mLg+TAM1/u+3x83553qcrl8VFVPtYpqjEm8OXP3GFU9AzxtFbie5oGNMdOe521k4Q5aMhigq6vrm6puBr7+Y/26v89EMEA+n3+jqsf+EfygXoOb1ktEbv8l8AVwfWpq6mzd2lkVrLWNvlAqwLkwDG8UCoXnWeHUGTcjEdnl+/79RvN197hZVSqVh83kWwbu6+tLfQD+12+WO/qt9E2iYgAAAABJRU5ErkJggg==" />
                  </i>
                  <span className="nav-text">Marketting</span>
                </Link>
                <ul>
              
                {permission.includes("Go One Coupens") && (
                    <li>
                      <Link
                        className={`${path === "coupens" ? "mm-active" : ""}`}
                        to="/coupens"
                      >
                        Go One Coupens
                      </Link>
                    </li>
                  )}
                  {permission.includes("Customer Notification") && (
                    <li>
                      <Link
                        className={`${path === "Customer-Notification" ? "mm-active" : ""}`}
                        to="/Customer-Notification"
                      >
                        Customer Notification
                      </Link>
                    </li>
                  )}
                 
                   
                 
                </ul>
              </li>
            )}
         
           {permission.includes("Category Analytics")||permission.includes("All Analytics")? (
              <li className={`${analitic.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img height={30} width={30} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB6UlEQVR4nO2ZQUoDMRSGRxfqQpcKHsCVeAB1Ie7UHkDPoTu7+P8XOtZuhG68gwvBMyheQAX32rq0bgQp1EowgSDjTKp1mmI+CAQmmXkfL3kTZpIkEolEIiEAYIpkA8ATyX5grU2yrmP0ETkOIOB+XgNwVChirPsispoEBoA1m5nCwdba9K9JXuX1y4ZOfN4DdbAALvP6YyESIhxUJPSW/DuRJFAYRQKDMSOBwZiRkhCRCoAWyUcR2R5ZRnwDyXnuo3O6fRiZiG8g3zBBsjNyEQALALrOm/cVwIzvfJJVVwLAVukiWoLkrQmiC+Dd3OMMwKTH/B2SPd1EpDK0+AYRSdN0HsCNmXNfq9UWlVLLAJ6N2GnefKXUkl1SAA59njl0kSwJe01ENgC8mWsHWfMBzDqZvND7JClTxFYnZ0/c6uWVcZ9du2QA7GVs7nMjcddoNOZ8JIYq8qU6dbMkLAD2zbg3EdnM2NwdvbwKgypBpLDMAjgxY1+UUivu5tb9woD+cGlta5miMmnRlUtXMHPfnlOiq4XBhHbWajab0/rd4kh0fDd3cIfGX775wxEZdEkGKzIsGEUCgzEjY5yRtimRa0lgiMi6ia1VOFj/ESrz0+cPW+r7661uMxNSw+c3gdTr11skEolEkhL4AAdT3U0RzEj+AAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Analytics</span>
                </Link>
                <ul>
              
                  {permission.includes("All Analytics") && (
                    <li>
                      <Link
                        className={`${path === "All-Analytics" ? "mm-active" : ""}`}
                        to="/All-Analytics"
                      >
                        Order Analytics
                      </Link>
                    </li>
                  )}    
                </ul>
               
               
              </li>
            ) : null}
            {permission.includes("Rider Support") ||
            permission.includes("Customer Support") ||
            permission.includes("FAQ") ||permission.includes("App Update")? (
              <li className={`${support.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img height={26} width={26} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEtklEQVR4nO2ZTYgcRRTHx48oRo2oCGo8qHgwGg+iKEQ9+HFwUZCwehAPIhLBbExMEN2cBrx40IWM0/Xaeq9n3+sZRBwRFfSkEAmoG0KyURe/ENSNUcEvNpGoRB153T3r7Hz31+wKKSiYaqqr6lf/916/qikUUhRr7SpjpzcY4ieBhIHkvV59DckeILHGyjbH49tLpdLpheUuYP07gNg3KEeApNFae77T1g+QFwC55qB/j27IiAFkzCDv61hUEpAlUPK1g7ypWCyenCtAqVK5AIhf6buYNCBRNcj7DPnrcoEAkusM8TfDLCQtCIQm95uDcm+mEI71b+7mB7mCUKDMX4bkoUwgwKuujwuRFQhEMID+3akgSrXaGkP8ZdzJswSBMAj86rp8aWIQIPESTZw1CAUwbyaCcEluMMj/rBgQUpjp22KDAMo7aSbNA8Qg7200GicND+FV16faubwUIWm4xDcNDWJInJUKYpDLQ0FoegAoh1cuiPxQr9dPGQjiVipXpZ0sTxDQitO3DAQB8h9c+SD8+Ej8I3cQYn8YkD0ZTDTXG4TnMlDkw4EggPxJ0gkMyu/G+pv7nSfCYMIT2jfFRh1/HquXDVCEv0sM4cmtOoYeX4F4KxDPaDoeVOIZl2RLvV4/TfvoMRdI/kiuirzaHyT5Tj2q77uurDUoB/v0m9U+kfoTuaUsQHwsgRoH1WRUiUUIlHmwPO553tlaXZSNBuWzsD8fUGX0HYP8cQqYj4rF3af2AjkUG8T6m6N3tzYhiOi89rH12eL4yBOhBfBj6VThiV6m1c8sulZr+cpoUXuDZ5bHg7bHdxnib4PFWxkLYD2+L4An+SCLD7BB+bns++d3KoLyWtzBpqbqZ0SKHNW2mlKHuijzQSCo1dZECziibWvt6lSKULApTqcinjwRd6CWhQ8Esdae0wrybLV6ZloQID5ettPXLAWx0xviDqTmES18JmijbAzaVsYCGJR5h/jO8BmPhyD8vrYdlKvTg0jDEL+8BESjiSH+MUnu03RcjU69nN2QfNEaIPTqNAsQiBRvj1xTMaWd09Q6/BDKbPTskDq2+kTgF5bHmxBAsl83TN8xJJ9mogjK7k4/IX9dbPMi2RJEIVfW/gfTte4ve97FWWbagPzTC55/ffcwTPxGvB3hPzXtaJqngqkfhAGAj+pvNadmihI5/iqD8rQ6azIIPgbEuxzmC7tCBE5I1Svi5kIKo37S7wSnX3OHZLv6RvMiwbHVG4H485gQu6ytXdQTYIkqKM8k3Kk5XaxeYjhO/awgxOqNpZVtzTQl6vd2CWuXROqsNsgw7BVUIU7RRWRxfh8A/YuDcn9zTvD8awFePFf9CFCeUpVTg2hxkR/IFyQyS5KXdOPa5wfiyUxA1I41Wx0FTDenLasyWYCEuyKPjAKkGZZbSxTO2/v+XUhSQl/hhfxheLJ9bkOys6MfyveFpAWIX8/dTwLH5klVJjhpkuzs7uz8bmKQJFlxbr5Esj3V32/LDQDRQapbQjp0gUrl8hWhBvKmQprSPNktsxrPpYJYVGW5IJAXDPLDmUCMCGTWkHylaZH+CWtQ3jLo79DjcWYQowDJdLH9ygkQOqFIPuX/YFr/AptZuD9EqtuJAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Support</span>
                </Link>
                <ul>
                  {permission.includes("Rider Support") && (
                    <li>
                      <Link
                        className={`${path === "support" ? "mm-active" : ""}`}
                        to="/support"
                      >
                        Rider Support
                      </Link>
                    </li>
                  )}
                  {permission.includes("Customer Support") && (
                    <li>
                      <Link
                        className={`${
                          path === "customer-support" ? "mm-active" : ""
                        }`}
                        to="/customer-support"
                      >
                        Customer Support
                      </Link>
                    </li>
                  )}
                  {permission.includes("FAQ") && (
                    <li>
                      <Link
                        className={`${path === "FAQ" ? "mm-active" : ""}`}
                        to="/FAQ"
                      >
                        FAQ
                      </Link>
                    </li>
                  )}
                   {permission.includes("App Update") && (
                    <li>
                      <Link
                        className={`${path === "App-Update" ? "mm-active" : ""}`}
                        to="/App-Update"
                      >
                        App Update
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            ) : null}
           
           
         
          
            {(permission.includes("All Staff") ||
              permission.includes("Roles")) && (
              <li className={`${staff.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon">
                  <i>
                    {" "}
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAACrElEQVRIie2Uz0sUYRzGP9/ZccE6eJAISsq8WIdEdl7dZbVOHbxU0EGoayF0MLJLRXazPERd6lBBBy8SZkH4F5Qlus6ERb8oMkwLLwYVEaw7frtsoLPvtKZ2KHyOz/N9n887M++8sK7/XfInw6OjozWu63YBbcD2ov1ERC55njf0V8Dj4+MHRKQf2BgzMqiqp5uamiZXBR4YGEjU1dVdAY4AlUASqAAGVPWyiDwHNgDHgIvFru9ACOSB/snJyVPt7e3hssFBELSrajewOxJdN8Ycj877vr9TRK6q6r5I9AzoMcbcKQsufsf3gBuJwjAMN6fT6TnbZicmJrYWCoUpIBGJ5h3HqU2lUp8Wm060wHXdNgsU4EMcFKCxsfEj8NYSVYRh2BY1S8BAdUz3tzjoIuVtpohsKgsWEduuAepHRkYq44jFrD4G/KYsWFUXYrqnstnsjzhwMZuyZaqqZcEikozprg2CIBMHLmY7YuKKsuBUKjUI9FkWJ1X1hqra3pKjqjdtAKDP87y7ZcEislAoFLqBWUtJQxAEPVEzCIILlP7zALOu654TkZLPZzvVZDKZGaDVlgFnLd6ZmNnW4m9WIisYwBjzLi5brn7XYQWrqvi+fyJmzQuL99I26Pt+p6par+UlZi6Xa0okEgdV9RCwa1E0DzxS1aEwDG9lMpmvEUAVcBTYD7Sw9JC9EpF7YRjeb25uHl8CDoJgj6peAxoiG5tR1R4RuW2M+WLbueUpq4DDwHlgSyR+KiKdnucNSy6XyzqO84DS+/l1Pp9vyWazn5cDjGpsbKw6kUg8pvQ2KziOs9cRkV4LFBE5uVIoQDqdnlPVLkvkqmqvIyLGtlBVh1cK/aVkMvkwptuUnDjf96eBmtVCI5o2xmxbbNiuvw5gZi2hItKxhn3r+kf0E8hi9OOpoD2gAAAAAElFTkSuQmCC" />
                  </i>
                  <span className="nav-text">Staff</span>
                </Link>
                <ul>
                  {permission.includes("All Staff") && (
                    <li>
                      <Link
                        className={`${path === "all-staff" ? "mm-active" : ""}`}
                        to="/all-staff"
                      >
                        All Staff
                      </Link>
                    </li>
                  )}
                  {permission.includes("Roles") && (
                    <li>
                      <Link
                        className={`${path === "all-roles" ? "mm-active" : ""}`}
                        to="/all-roles"
                      >
                        Roles
                      </Link>
                    </li>
                  )}
                  {/* <li><Link className={`${path === "agent-table" ? "mm-active" : ""}`} to="/agent-table">Staff Permissions</Link></li> */}
                  {/* <Link className="has-arrow ai-icon" to="/all-roles" ><i> <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAABtklEQVRIie2WP2sUQRjGf+/orRy2dirE3up2BlOokFKs9SMcQgiY76Bom858BjsRbEWxmzktXEgpJFXA4qqLOW5em6ysm927WbkV/PN088zO85t3dtl34F+TNJne+/vAPnC1PmetFYAQwgdVjdbaO2drtCHqSFXHzrk39QnTsqEXTdCqVDUCTbCqronIftPExbYFKwIpK03Q9SazreJWee9v170QQuomfqit4mV6773/yVBddeLn1bnidek/OEVfVPXBYrG4YozZAF4CJ11Dun5cJ8A959zB2fgr8HAymdyNMb6l5YfUpK4Ve2vtQd0cjUbvgKJLUCewiCw70m+9gVV103s/qPtFUWTAzd7AgAyHw3PvcTqdXgBin+DLs9nsWd3Msuw5MOwTDLDtvb9VDkIIm8CjriG/Ar4EbJUDVd0Cst8BPhWRzxVwAZz2Cf4IPAY28jx/XZrOuVfGmBsisgt8Sg1ru/rU+9xenue7IrK0/6mqhBD2gJ2qX16Xqkqq2BjzdBUUQER0MBg8SclM+lfHGI/rzb9N8/k86bk/qi32Cj5aI+MwGayq4zXBD0VkvIacv0DfARpHiIwLMZqyAAAAAElFTkSuQmCC" /></i><span className="nav-text">Roles</span></Link> */}
                </ul>
              </li>
            )}
          

          

          

          
          </MM>
        )}
        <div className="copyright">
          <p>
            <strong>K Health Admin Dashboard</strong> © {new Date().getFullYear()}{" "}
            All Rights Reserved
          </p>
          <p className="fs-12">
            Made with <span className="heart"></span> by K Health
          </p>
        </div>
      </PerfectScrollbar>
     
    </div>
  );
};

export default SideBar;
